"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "piadena-drizzona": {
    "64339e5a": [{
      "hkey": "1a71a2a3",
      "slug": "san-paolo-ripa-d-oglio",
      "name": "San Paolo Ripa d'Oglio",
      "primary": true,
      "skipSearch": false
    }],
    "san-paolo-ripa-oglio": [{
      "hkey": "1a71a2a3",
      "slug": "san-paolo-ripa-d-oglio",
      "name": "San Paolo Ripa d'Oglio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;